export default __webpack_public_path__ + "static/ebook1-2dc4b4b5a30c820977e9db49ddb7ce76.jpg";